import React from 'react';
import { Facebook, Telegram, WhatsApp, CopyIcon } from '../../../../../Assets/Icons';
import Button from '../../../../../Components/Button/button';
import { ButtonTypes } from '../../../../../Interfaces/componentTypes';
import styles from './qrCodeCard.module.scss';

export interface IQrCodeCardProps {
    imageUrl: string;
    title: string;
    badge?: string;
    link: string;
    downloadLabel: string;
    shareLabel: string;
    linkLabel: string;
    copyLinkLabel: string;
    onDownload: () => void;
    onCopyLink: () => void;
    onShareTelegram: () => void;
    onShareWhatsApp: () => void;
    onShareFacebook: () => void;
}

const QrCodeCard: React.FC<IQrCodeCardProps> = ({
    imageUrl,
    title,
    badge,
    link,
    downloadLabel,
    shareLabel,
    linkLabel,
    copyLinkLabel,
    onDownload,
    onCopyLink,
    onShareTelegram,
    onShareWhatsApp,
    onShareFacebook,
}) => (
    <article className={styles.card}>
        <div className={styles.cardHeader}>
            <p className={styles.cardTitle}>{title}</p>
            {badge && <span className={styles.badge}>{badge}</span>}
        </div>

        <div className={styles.imageBox}>
            <img src={imageUrl} alt={title} loading="lazy" />
        </div>

        <Button
            title={downloadLabel}
            buttonType={ButtonTypes.Primery}
            onClick={onDownload}
            buttonTitleStyle={styles.buttonTitle}
            buttonStyle={styles.downloadButton}
        />

        <div className={styles.linkBox}>
            <p className={styles.linkLabel}>{linkLabel}</p>
            <div className={styles.linkRow}>
                <input
                    className={styles.linkInput}
                    value={link}
                    readOnly
                    onFocus={(event) => event.target.select()}
                />
                <button type="button" className={styles.copyButton} onClick={onCopyLink}>
                    <img src={CopyIcon} alt="" />
                    <span>{copyLinkLabel}</span>
                </button>
            </div>
        </div>

        <div className={styles.shareBox}>
            <div className={styles.buttonsDivider}>
                <div className={styles.dividerLine} />
                <p className={styles.dividerText}>{shareLabel}</p>
                <div className={styles.dividerLine} />
            </div>
            <div className={styles.socialBox}>
                <img src={Telegram} onClick={onShareTelegram} alt="telegram" className={styles.socialIcon} />
                <img src={WhatsApp} onClick={onShareWhatsApp} alt="whatsapp" className={styles.socialIcon} />
                <img src={Facebook} onClick={onShareFacebook} alt="facebook" className={styles.socialIcon} />
            </div>
        </div>
    </article>
);

export default QrCodeCard;
